import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/classes/Message';
import { INonMovementTransaction } from 'src/app/interfaces/non-movement-transaction';
import { IPageResult } from 'src/app/interfaces/page-result';
import { EventService } from 'src/app/services';
import { NonMovementTransactionService } from 'src/app/services/non-movement-transaction.services';

@Component({
  selector: 'app-search-non-movement-transactions',
  templateUrl: './search-non-movement-transactions.component.html',
  styleUrls: ['./search-non-movement-transactions.component.css'],
})
export class SearchNonMovementTransactionsComponent implements OnInit, OnDestroy {
  public page: IPageResult<any> = {
    items: [],
    total: 0,
  };
  public transactionSearchEvent: Subscription;
  public query: string;
  public isLoaded: boolean;
  public selectedTransaction: INonMovementTransaction;
  public transactions: INonMovementTransaction[];
  public transactionHistoryTimeline: any[];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private nonMovementTransactionService: NonMovementTransactionService,
    private messageService: MessageService,
  ) {
    this.transactionSearchEvent = this.eventService.TransactionSearchEvent.subscribe((input) => {
      if (input.runSearch == true) {
        this.search();
      }
    });
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.selectedTransaction = null;
    this.query = this.route.snapshot.params['data'];
    this.query = this.query.replace(' ', '');

    this.nonMovementTransactionService.searchTransactions(this.query).then((items) => {
      this.isLoaded = true;
      this.transactions = items;
      this.eventService.TransactionSearchEvent.emit({ searchComplete: true });
      if (items.length == 1) {
        this.selectedTransaction = this.transactions[0];
        this.showDetails();
      }
    });
  }
  showDetails() {
    this.getHistories();
  }

  getHistories() {
    this.nonMovementTransactionService
      .getHistory(this.selectedTransaction.id)
      .then((res) => {
        if (res) {
          this.transactionHistoryTimeline =
            this.nonMovementTransactionService.getHistoryTimelineFromTransactionHistories(res);
        } else {
          //show error that nothin was returned
          this.messageService.add(Message.Error('History not found for Transaction', 'Error'));
        }
      })
      .catch((err) => {
        this.messageService.add(Message.Error(err.error, 'Error'));
      });
  }

  ngOnDestroy() {
    this.transactionSearchEvent.unsubscribe();
  }
}
